// #2261 — the ride-side test-slug derivation the test-disagreement tooltip
// (TestDisagreementChip, #2252) needs, extracted to a util so it reads from
// useClassesNeedingPlacings' show-scoped ridesByClassId instead of firing a
// per-class GET /ride?classId= for every flagged class (the deleted
// useTestDisagreementRideTests hook, whose fetchedRef cache also never
// invalidated — a re-reconcile landing mid-session left the tooltip naming
// stale ride-side tests).

// #2251's Class.testDisagreement (score-api's computeTestDisagreement,
// apps/score-api/src/handlers/daysheet.js) only ever compares against a
// class's own REAL bound testId — never against the fvd-unmatched:<n>
// fallback sentinel a class/ride gets when FVD's test string didn't resolve
// to a catalog def. This mirrors that same one-line predicate
// (apps/score-api/src/lib/catalog-enrich.js:492, isRealTestSlug) so the FE
// doesn't list an unresolved sentinel id next to a real test name — FE has
// no import path into API-only code, so this is a deliberate duplicate, not
// a fork; a change to the backend predicate needs the same change here.
export function isRealTestSlug(slug) {
  return typeof slug === "string" && slug.length > 0 && !slug.startsWith("fvd-unmatched:");
}

// The distinct REAL test slugs a class's rides resolve to, ride order
// preserved. May include a slug equal to the class's own test, per card
// #2252's class-814 example: a class can have some rides on the correct
// test and others on a different one, so the full set is what the operator
// needs to see, not just the mismatched slugs. Unresolved
// fvd-unmatched:<n> sentinels are filtered out (isRealTestSlug above).
export function distinctRealRideTestIds(rides) {
  return [...new Set((rides || []).map((r) => r?.testId).filter(isRealTestSlug))];
}
